import { useEffect } from 'react';
import { fetchBirthdayRequestRecommendations } from '@actions/birthdays';
import { openModal, selectActiveModalType } from '@actions/ui';
import { useAuthContext } from '@hooks/use-auth-context';
import { selectBirthdayRequestRecommendations } from '@reducers/data/birthdays';
import { useDispatch, useSelector } from 'react-redux';

export default function RequestMissingBirthdaysCallout({
  dismissCallout,
}: {
  dismissCallout?: () => void;
}) {
  const dispatch = useDispatch();
  const { user } = useAuthContext();
  const birthdayRequestRecommendations = useSelector(selectBirthdayRequestRecommendations);
  const activeModal = useSelector(selectActiveModalType);

  useEffect(() => {
    dispatch(fetchBirthdayRequestRecommendations());
  }, []);

  useEffect(() => {
    if (
      user.has_completed_onboarding &&
      birthdayRequestRecommendations.length > 0 &&
      !activeModal
    ) {
      dispatch(openModal('requestMissingBirthdays', { source: 'userCallout' }));
      dismissCallout();
    }
  }, [birthdayRequestRecommendations]);

  return null;
}
